import {
  LIST_ANALYSE_FAILED,
  LIST_ANALYSE_SUCCESS,
  LIST_ANNOTATION_DATA,
  LIST_SET_ALERT_ANALYSE,
  LIST_STITCHED_ANALYSE_DATA_SUCCESS,
  SET_ANALYSE_SECTION_ID,
  LIST_DAMAGE_DATA,
  LOADING_ANNOTATION_DATA,
  LIST_IMAGE_ANALYSE_DATA_SUCCESS,
  LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS,
  LIST_STITCHED_ANALYSE_DATA_SUCCESS_LOADING,
  LIST_STITCHED_RAW_SUCCESS_LOADING,
  LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS_LOADING,
  SELECT_DAMAGE_AUTOMATIC,
  SET_NEW_DAMAGE_ID,
  TRIGGER_MARK_NO_DAMAGE,
  TRIGGER_MARK_NO_DAMAGE_2,
  SAVE_LOADING_STOP,
  DAMAGE_DATA_ANALYSE_LOADING,
} from "../actions/types";
const initialState = {
  loading: false,
  data: [],
  isOpen: false,
  isAlert: false,
  alertType: null,
  alertMessage: null,
  annotateData: [],
  selectedSection: null,
  stitchedImages: [],
  stitchedImagesLoading: false,
  damageData: [],
  damageDataLoading: false,
  loadingAnnotate: false,
  annotationImage: [],
  enhancedImages: [],
  rawLoading: false,
  enhancedImagesLoading: false,
  selectAuto: null,
  newDamageId: null,
  markNoDamage: false,
  markNoDamage2: false,
  saveLoading: false,
};

function companyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SAVE_LOADING_STOP:
      return {
        ...state,
        saveLoading: payload,
      };
    case TRIGGER_MARK_NO_DAMAGE:
      return {
        ...state,
        markNoDamage: payload,
      };
    case DAMAGE_DATA_ANALYSE_LOADING:
      return {
        ...state,
        damageDataLoading: payload,
      };
    case TRIGGER_MARK_NO_DAMAGE_2:
      return {
        ...state,
        markNoDamage2: payload,
      };
    case SET_NEW_DAMAGE_ID:
      return {
        ...state,
        newDamageId: payload,
      };
    case SELECT_DAMAGE_AUTOMATIC:
      return {
        ...state,
        selectAuto: payload,
      };
    case LIST_STITCHED_RAW_SUCCESS_LOADING:
      return {
        ...state,
        rawLoading: payload,
      };
    case LOADING_ANNOTATION_DATA:
      return {
        ...state,
        loadingAnnotate: payload,
      };
    case LIST_DAMAGE_DATA:
      return {
        ...state,
        damageData: payload,
      };
    case LIST_STITCHED_ANALYSE_DATA_SUCCESS:
      return {
        ...state,
        stitchedImages: payload,
        stitchedImagesLoading: false,
      };
    case LIST_STITCHED_ANALYSE_DATA_SUCCESS_LOADING:
      return {
        ...state,
        stitchedImagesLoading: payload,
      };
    case LIST_IMAGE_ANALYSE_DATA_SUCCESS:
      return {
        ...state,
        annotationImage: payload,
      };
    case LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS:
      return {
        ...state,
        enhancedImages: payload,
        enhancedImagesLoading: false,
      };
    case LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS_LOADING:
      return {
        ...state,
        enhancedImagesLoading: payload,
      };
    case SET_ANALYSE_SECTION_ID:
      return {
        ...state,
        selectedSection: payload,
      };
    case LIST_ANALYSE_SUCCESS:
      return {
        ...state,
        loading: payload.loading,
        data: payload.data,
      };
    case LIST_ANNOTATION_DATA:
      return {
        ...state,
        annotateData: payload.data,
      };
    case LIST_ANALYSE_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
      };
    case LIST_SET_ALERT_ANALYSE:
      return {
        ...state,
        isAlert: payload.isAlert,
        alertType: payload.alertType,
        alertMessage: payload.alertMessage,
      };
    default:
      return state;
  }
}

export default companyReducer;
